import * as React from 'react';
import {StyleSheet, View} from 'react-native';
import Styles from '../../Styles';
import AVFormattedCurrency from '../AVFormattedCurrency';
import type {CartItem} from 'src/types/TransactionDetail';
import AVText from '../AVText';
type SaleDetailProps = {
  detail: CartItem;
};

const SaleDetail = (props: SaleDetailProps) => {
  let itemPrice = parseFloat(props.detail.Price);
  let modifiers = null;

  if (props.detail.Modifiers && props.detail.Modifiers.length > 0) {
    props.detail.Modifiers.sort((a, b) => b.Price - a.Price);

    modifiers = props.detail.Modifiers.map((mod) => {
      itemPrice -= mod.Price;
      let price = null;

      if (mod.Price > 0) {
        price = (
          <AVText key={mod.Id} style={styles.modifierAmount}>
            +
            <AVFormattedCurrency
              style={styles.modifierAmount}
              value={mod.Price}
              accessibilityLabel="price"
            />
          </AVText>
        );
      }

      return (
        <View key={mod.Id} style={styles.row}>
          <AVText numberOfLines={1} style={styles.modifier}>
            {mod.Name}
          </AVText>
          {price}
        </View>
      );
    });
  }

  return (
    <View>
      <View style={styles.row}>
        <AVText numberOfLines={1} style={styles.item}>
          {props.detail.Name}
        </AVText>
        <AVFormattedCurrency
          style={styles.amount}
          value={itemPrice}
          accessibilityLabel="price"
        />
      </View>
      {modifiers}
    </View>
  );
};

const styles = StyleSheet.create({
  amount: {
    color: Styles.darkColor,
    fontSize: Styles.Fonts.f1,
  },
  item: {
    color: Styles.darkColor,
    flex: 1,
    fontSize: Styles.Fonts.f1,
    marginRight: Styles.Spacing.m2,
  },
  modifier: {
    flex: 1,
    color: Styles.auxColor,
    fontSize: Styles.Fonts.f1,
    marginRight: Styles.Spacing.m2,
  },
  modifierAmount: {
    color: Styles.auxColor,
    fontSize: Styles.Fonts.f1,
  },
  row: {
    alignItems: 'center',
    backgroundColor: Styles.white,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: Styles.Spacing.m0,
  },
});
export default SaleDetail;
